import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./Components/Pages/Home/HomePage";
import About from "./Components/Pages/About";

import ScrollToTopButton from "./Components/Scroll/ScrollToTopButton";
import TermsAndConditions from "./Components/Pages/TermsAndConditions";

import WhatsappButton from "./Components/Scroll/WhatsappButton";
import Contact from "./Components/Pages/Contact";
import VendorHome from "./Components/Pages/Vendor/VendorHome";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import ScrollToTop from "./Components/Scroll/ScrollToTop";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<VendorHome />} />
          <Route path="/contact-us" element={<Contact />} />{" "}
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <WhatsappButton />
        <ScrollToTopButton />
      </BrowserRouter>
    </div>
  );
};

export default App;
